export default "__VITE_ASSET__BE0sxPT4__"